import register from '../../../../global/js/registry';
export default register('m-fhw-profile-sliders', () => import(/* webpackMode: "lazy" */ './m-fhw-profile-sliders.controller'));
